import { Injectable } from '@angular/core';

@Injectable()
export class RaceProvider {

constructor() {
    
}


}


// WEBPACK FOOTER //
// /src/providers/race-provider/race-provider.ts